import AuthError from '~lib/authError';
import { getLocalToken } from '~util/token';
import BadRequestError from './badRequestError';

const { fetch } = window;

const API_URL = '/api';
const API_VERSION = '/v1';

const get = async url => {
  const config = {
    method: 'GET',
    headers: { 'content-type': 'application/json' },
  };
  const response = await fetch(`${API_URL}${API_VERSION}${url}`, config);
  return response.json();
};

const getSecure = async url => {
  const headers = getAuthHeaders();

  const config = {
    method: 'GET',
    headers,
  };

  const response = await fetch(`${API_URL}${API_VERSION}${url}`, config);

  return await handleResponse(response);
};

const post = async (url, body = null) => {
  const config = {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
  };
  if (!!body) config.body = JSON.stringify(body);

  const response = await fetch(`${API_URL}${API_VERSION}${url}`, config);
  return response.json();
};

const postSecure = async (url, data = null) => {
  const headers = getAuthHeaders();

  const config = {
    method: 'POST',
    headers,
  };
  if (!!data) config.body = JSON.stringify(data);

  const response = await fetch(`${API_URL}${API_VERSION}${url}`, config);

  return await handleResponse(response);
};

const putSecure = async (url, data = null) => {
  const headers = getAuthHeaders();

  const config = {
    method: 'PUT',
    headers,
  };
  if (!!data) config.body = JSON.stringify(data);

  const response = await fetch(`${API_URL}${API_VERSION}${url}`, config);

  return await handleResponse(response);
};

async function handleResponse(response) {
  const success = checkResponseStatus(response);
  const body = await response.json();
  if (response.status === 400) throw new BadRequestError(body?.message ?? null);
  return {
    data: body,
    status: response.status,
    success,
  };
}

const getAuthHeaders = () => {
  const token = getLocalToken();
  if (!token) {
    console.warn('No token found, invalidating session');
    throw new AuthError('No token found, invalidating session');
  }
  return { 'content-type': 'application/json', Authorization: `Bearer ${token}` };
};

const checkResponseStatus = res => {
  if (res.status === 403 || res.status === 401)
    throw new AuthError('Unauthorized/Forbidden response received from server');
  return !(res.status >= 400 && res.status < 600);
};

export { get, getSecure, post, postSecure, putSecure };
